import LearningTimeBreakdown from '@Components/LearningTimeBreakdown/LearningTimeBreakdown'
import { FlexLayout } from '@eduact/ed-system'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router'
import styled from 'styled-components'

/** Classroom-scope learning time — the shared breakdown donut under the classroom analytics header. */
const LearningTimeWidget = () => {
	const { id } = useParams<{ id: string }>()
	const [t] = useTranslation('classroomsOverview')

	return (
		<Wrapper flexDirection="column" alignItems="center">
			<Header>{t('learningTime')}</Header>
			<ChartWrapper flexDirection="row" alignItems="center">
				<LearningTimeBreakdown scope={{ classroom_id: Number(id) }} skip={!Number(id)} />
			</ChartWrapper>
		</Wrapper>
	)
}

const Wrapper = styled(FlexLayout)`
	background-color: #fff;
	border-radius: 5px;
	width: 100%;
	height: 250px;
	padding: 0.513rem 0.825rem;
	${({ theme }) => `${theme.mediaQueries.large}{
		padding: 0.963rem 0.556rem;
    	border-radius: 15px;
    	min-height: 18.55rem;
		min-width: 18.938rem;
	}`}
`
const ChartWrapper = styled(FlexLayout)`
	border-radius: 5px;
	width: 100%;
	height: 250px;
	padding: 0.513rem 0.825rem;
	${({ theme }) => `${theme.mediaQueries.large}{
		padding: 0.963rem 0.556rem;
    	border-radius: 15px;
    	min-height: 18.55rem;
		min-width: 18.938rem;
	}`}
`
const Header = styled.p`
	font-weight: 600;
	color: #1F2937;
	font-size: 0.75rem;
	${({ theme }) => `${theme.mediaQueries.large}{
		font-size: 1.125rem;
	}`}
`
export default LearningTimeWidget
